// Mock data for ERM Relocations

export const companyInfo = {
  name: "ERM RELOCATIONS L.L.C",
  shortName: "ERM",
  fullName: "ERM RELOCATIONS L.L.C",
  tagline: "MOVING THE WORLD FORWARD ONE SHIPMENT AT A TIME",
  description:
    "Reliable and secure relocation, storage, and cargo services across the UAE and worldwide — managed with care, efficiency, and an unwavering focus on customer satisfaction.",
  phone: "+971 55 272 4569",
  email: "info@ermrelocations.com",
  whatsapp: "971552724569",
  address: "Dubai, United Arab Emirates",
};

export const services = [
  {
    id: 1,
    title: "INTERNATIONAL RELOCATION SEA CARGO SERVICES WORLDWIDE",
    description:
      "Trust our reliable team for door-to-door relocation at affordable rates—safe, smooth, and stress-free. Worldwide SEA import & export services with professional handling and timely delivery. Your move, our mission—powered by expertise & care",
    image: "https://images.unsplash.com/photo-1613690399151-65ea69478674",
  },
  {
    id: 2,
    title: "INTERNATIONAL RELOCATION AIR CARGO SERVICES WORLDWIDE",
    description:
      "Experience trusted Door-to-Door Relocation Services for import & export—affordable, secure, and fully trackable. Our expert team ensures safe handling with optional wooden crating for fragile items, backed by true commitment at every step.",
    image: "https://images.unsplash.com/photo-1571086291540-b137111fa1c7",
  },
];

export const whyChooseUs = [
  {
    icon: "Award",
    title: "Professional Expertise",
    description:
      "A skilled team with global experience ensures every move and shipment is handled with precision and professionalism.",
  },
  {
    icon: "Truck",
    title: "On-Time Delivery",
    description:
      "We respect your time and guarantee timely delivery through efficient coordination and careful planning.",
  },
  {
    icon: "Recycle",
    title: "End-to-End Solutions",
    description:
      "From consultation to delivery, we handle every detail so you can focus on what matters most.",
  },
  {
    icon: "ShieldCheck",
    title: "Safety & Security",
    description:
      "Your belongings are protected with advanced tracking, secure handling, and high safety standards.",
  },
  {
    icon: "Headphones",
    title: "24/7 Support",
    description:
      "Our friendly support team is available anytime to guide and assist you throughout your move.",
  },
];

export const faqs = [
  {
    question: "What services does ERM CARGO & PACKAGING LLC provide?",
    answer:
      "We specialize in door-to-door international and domestic moving services, including professional packing, secure transportation, customs clearance, storage, and unpacking. Whether you're relocating your home or office, we ensure a smooth, stress-free experience.",
  },
  {
    question: "Do you handle both residential and commercial moves?",
    answer:
      "Yes, we provide tailored moving solutions for both homes and offices of all sizes, ensuring minimal disruption to your daily life or business.",
  },
  {
    question: "Can you move items within the UAE as well as internationally?",
    answer:
      "Absolutely. We handle local moves across the UAE, GCC region, and international relocations to over 200 destinations worldwide.",
  },
  {
    question: "How do I get a moving quote?",
    answer:
      "Simply fill out our contact form, call us at +971 52 409 4569, or WhatsApp our team. We provide free, no-obligation quotes within 24 hours.",
  },
  {
    question: "What factors affect the cost of my move?",
    answer:
      "Cost is determined by volume of belongings, distance, mode of transport (sea/air/land), packing materials, and any special handling requirements.",
  },
  {
    question: "Are there hidden charges?",
    answer:
      "No. We provide transparent, all-inclusive quotes with no hidden fees. Every cost is discussed and agreed upon before we begin.",
  },
  {
    question: "Do you provide packing materials and services?",
    answer:
      "Yes. We supply high-quality packing materials including wooden crates, bubble wrap, and specialty containers for fragile and valuable items.",
  },
  {
    question: "Can I pack my own items?",
    answer:
      "Yes, self-packing is an option. However, note that manufacturer packing is required for insurance coverage on delicate items.",
  },
  {
    question: "How do you ensure the safety of my belongings?",
    answer:
      "We use professional packing techniques, secure vehicles, GPS tracking, trained staff, and comprehensive insurance to protect every shipment.",
  },
  {
    question: "Do you handle customs clearance?",
    answer:
      "Yes. Our experienced team manages all customs documentation and clearance procedures for both import and export shipments.",
  },
  {
    question: "How long does an international move take?",
    answer:
      "Sea freight typically takes 25–45 days depending on destination. Air freight is much faster, usually 5–10 days door-to-door.",
  },
  {
    question: "Can you ship vehicles overseas?",
    answer:
      "Yes, we offer specialized vehicle shipping via container or roll-on/roll-off (RoRo) services to destinations worldwide.",
  },
  {
    question: "How quickly can you arrange a local move?",
    answer:
      "Local moves within the UAE can often be arranged within 24–48 hours, subject to team availability.",
  },
  {
    question: "Do you offer same-day or urgent moving services?",
    answer:
      "Yes, we provide express and same-day moving services for urgent relocations at competitive rates.",
  },
  {
    question: "Is my shipment insured?",
    answer:
      "All shipments are covered by comprehensive marine and transit insurance. Additional coverage options are available on request.",
  },
  {
    question: "What happens if something is damaged during the move?",
    answer:
      "In the rare event of damage, our claims team will guide you through the insurance process for quick resolution.",
  },
  {
    question: "Do you offer storage facilities?",
    answer:
      "Yes, we provide short-term and long-term secure storage in climate-controlled facilities across the UAE.",
  },
  {
    question: "Can you help with unpacking and setup at my new location?",
    answer:
      "Absolutely. Our full-service package includes unpacking, furniture assembly, and setup at your new address.",
  },
  {
    question: "How far in advance should I book my move?",
    answer:
      "We recommend booking at least 2–4 weeks in advance for international moves, and 1 week for local moves for best scheduling.",
  },
  {
    question: "How can I contact customer support during my move?",
    answer:
      "Our support team is available 24/7 by phone, WhatsApp, or email. You'll also have a dedicated move coordinator throughout your relocation.",
  },
];

export const testimonials = [
  {
    name: "Aaliyah Igwe",
    text: "The team was great .. My items reached safe and undamaged. Its the best experience and i would like to refer this to my other friends... Thanks",
    rating: 5,
  },
  {
    name: "Mohammed Al-Farsi",
    text: "Professional and punctual. They packed my entire villa in Dubai and delivered everything to London without a single scratch. Highly recommend ERM Relocations.",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    text: "Smooth international move from UAE to India. Their customs handling was seamless and the pricing was very transparent. Thank you team ERM!",
    rating: 5,
  },
];

export const images = {
  hero: "https://images.unsplash.com/photo-1629089077520-c92fa3d532e5",
  about: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0",
  relocate: "https://images.unsplash.com/photo-1581573833610-487d80de9aab",
  faqBg: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242",
};
